<template>
 <common-dialog
      ref="dialog"
      width="750px"
      :show-save-button="true"
      unit="撤销"
      id-key="ClassId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="cancel==='1'?api.cancel:cancel==='2'?api.cancelPublish:api.cancelExamine"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
      @data-got='infoFun'
    >
   <template slot="form">
       <el-row>
          <el-col>
            <el-form-item label="备注" prop="Remark">
               <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
       </el-row>
   </template>
    <!-- <template slot="footer">
      <slot name="footer">
        <el-button type="primary" size="small" @click="close">关 闭</el-button>
      </slot>
    </template> -->
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: {
    commonDialog,
  },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "学生明细",
    },
  },
  data() {
    return {
      api: require("@/api/gd/eduresult").default,
      data: {
        RecordId:0,
        Remark:""
      },
      main: [],
      ExamNames: "",
      ExamIds: [],
      tableData: [],
      type: null,
      rules:{},
      cancel:sessionStorage.getItem('cancel')
    };
  },
  methods: {
    infoFun(row){
      this.data.Remark=''
     this.data.RecordId=row.EduResultId
    },
    onCreateOpened(row) {
    },

    onEditOpened(type) {
        this.cancel=sessionStorage.getItem('cancel')
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  margin-bottom: 10px;
  .info {
    display: inline-block;
    margin-right: 40px;
  }
}
.examSearch {
  padding-top: 10px;
  margin-bottom: 20px;
}
.detailsTable {
  margin: 20px 0;
}
.examInp {
  width: calc(100% - 70px);
  /deep/ .el-input__inner {
    width: 100%;
  }
}
</style>
